import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetSemesterCourseSubjectsParams, IGetSubjects } from '../models/subject.model';

const uri = '/mgmt/subject';

export const getSubjects = (): AxiosPromise<IGetSubjects> => {
  return axios.get(uri);
};

export const getSemesterCourseSubjects = (params: IGetSemesterCourseSubjectsParams): AxiosPromise<IGetSubjects> => {
  return axios.get(`${uri}/semester-courses`, { params });
};
